import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

const THEME_STORAGE_KEY = 'mfs_homepage_theme';
const THEMES = {
  PREMIUM: 'premium',
  CLASSIC: 'classic'
};

export function ThemeProvider({ children }) {
  const [homepageTheme, setHomepageTheme] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    return saved || THEMES.PREMIUM; // Default to premium
  });

  // Persist theme preference to localStorage
  useEffect(() => {
    localStorage.setItem(THEME_STORAGE_KEY, homepageTheme);
  }, [homepageTheme]);

  const toggleTheme = () => {
    setHomepageTheme(prev => prev === THEMES.PREMIUM ? THEMES.CLASSIC : THEMES.PREMIUM);
  };

  const isPremium = homepageTheme === THEMES.PREMIUM;
  const isClassic = homepageTheme === THEMES.CLASSIC;

  return (
    <ThemeContext.Provider value={{ 
      homepageTheme, 
      setHomepageTheme, 
      toggleTheme,
      isPremium,
      isClassic,
      THEMES
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
